import { GET_RATE_CONFIGS_FAILURE, GET_RATE_CONFIGS_REQUEST, GET_RATE_CONFIGS_REST, GET_RATE_CONFIGS_SUCCESS } from "@/redux/actions/RateManagement/GetRateConfigs";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const getRateConfigsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_RATE_CONFIGS_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case GET_RATE_CONFIGS_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, data: null, error: null });
        case GET_RATE_CONFIGS_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        case GET_RATE_CONFIGS_REST:
            return Object.assign(Object.assign({}, state), { loading: false, data: null, error: null });
        default:
            return state;
    }
};
export default getRateConfigsReducer;
